const getters = {
  waitingForApprovalList: (state) => state.controlPoints.filter(item => item.execution_status === 'waiting_for_approval'),
  inProgressList: (state) => state.controlPoints.filter(item => item.execution_status === 'in_progress'),
  inClosureProcessList: (state) => state.controlPoints.filter(item => item.execution_status === 'in_closure_process'),
  completedList: (state) => state.controlPoints.filter(item => item.execution_status === 'completed'),
};

export default getters;
